import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Nillable } from '@web/utils';
import { RouteQueryParam } from '../enums/route-query-param';

export const activatedRouteQueryParamAsString = (
  queryParam: RouteQueryParam,
): Observable<Nillable<string>> => {
  const activatedRoute = inject(ActivatedRoute);

  return activatedRoute.queryParamMap.pipe(
    map((queryParams) => queryParams.get(queryParam)),
  );
};
